export default __webpack_public_path__ + "static/media/ico_triangle.4ec2caf0.svg";